<template>
  <div class="row">
    <div class="label">{{ name }}</div>
    <div class="file">
      <!-- <el-button type='primary' @click="save" class="btn-upload" size="small">上传</el-button> -->
      <upload-btn @changed="Upload" text="上传报名文件"></upload-btn>
      <div class="file-list">
        <div v-for="(item, index) in List" :key="index" class="file-item">
          <a class="file-name" :src="uploadAddr + item.appendurl" @click="downFile(item.appendurl)">{{ item.appendfilename
          }}</a>
          <span class="btn-delete" @click="DELETE(item)">删除</span>
        </div>
      </div>
      <el-button class="btn-save" type='primary' @click="save" size="small">保存</el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import common from "@/mixin/common";
import uploadBtn from "../../views/common/uploadBtn";
export default {
  name: 'FileDownload',
  mixins: [common],
  components: {
    uploadBtn
  },
  props: {
    id: Number,
    fieldtype: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      default: '竞价文件'
    },
    List: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
  },
  methods: {
    async DELETE(item) {
      this.$emit('Delete', item)
    },
    async Upload(path, filename) {
      let { fieldtype, List, id, uploadAddr } = this

      let append = {
        appendid: 0,
        appendfromid: id,
        appendfromtype: fieldtype,
        appendtype: 100,
        appendseq: List.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(uploadAddr, ""),
      };
      this.$emit('uploadFile', append);
    },
    async save() {
      this.$confirm(`是否确定保存`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let { id, List, fieldtype } = this
        let data = await request({
          url: "/ywgl/append/addAppendList",
          method: "post",
          data: { id, fieldtype, List },
        });
        if (data.issuccess === 1) {
          this.$message.success(data.code)
          this.$emit('saveSuccess')
        } else {
          this.$message.error('保存失败！')
        }
      })
    }
  }
}

</script>


<style lang="scss" scoped>
.row {
  margin: 20px 0;
  display: flex;

  .label {
    margin-right: 10px;
  }

  .file {
    cursor: pointer;

    .btn-upload {
      width: 200px;
    }

    .file-list {
      margin: 10px 0;
      color: #66b1ff;

      .file-item {
        .file-name {
          margin-right: 10px;
        }

        .btn-delete {}
      }
    }

    .btn-save {}
  }
}
</style>
